import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/profile-pic.png";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import "./Home.css";

function Home() {
  return (
    <section className="home-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10} className="text-center">
            <div className="image-wrapper">
              <div className="image-container">
                <img
                  src={myImg}
                  alt="Rodrigue KOUETE"
                  className="profile-image"
                />
              </div>
            </div>

            <div className="content-wrapper">
              <span className="header-badge">Ingénieur DevOps</span>

              <h1 className="main-heading">
                <span className="greeting">Hi, I am</span>
                <span className="name">Rodrigue KOUETE</span>
                <span className="tagline">
                  Building scalable BPM & cloud solutions with Camunda and AWS
                </span>
              </h1>

              <p className="description">
                I'm an Ingénieur DevOps with 9+ years of experience designing and
                delivering business process automation and cloud platforms.
                Expert in Java, Python and Node.js, specializing in Camunda
                BPM, microservices, and AWS cloud infrastructure — from
                serverless functions to Kubernetes deployments and
                infrastructure as code.
              </p>

              <div className="stats-grid">
                <div className="stat-card">
                  <span className="stat-number">9+</span>
                  <span className="stat-label">Years experience</span>
                </div>
                <div className="stat-card">
                  <span className="stat-number">5</span>
                  <span className="stat-label">Companies</span>
                </div>
                <div className="stat-card">
                  <span className="stat-number">2</span>
                  <span className="stat-label">AWS / Terraform certs</span>
                </div>
              </div>

              <div className="social-links">
              <button
                  type="button"
                  className="social-link"
                  onClick={() => window.open("https://github.com/rkouete", "_blank")}
                >
                  <AiFillGithub />
                </button>

                <button
                  type="button"
                  className="social-link"
                  onClick={() => window.open("https://www.linkedin.com/in/rodrigue-kouete-790501129/", "_blank")}
                >
                  <FaLinkedinIn />
                </button>
                <a href="mailto:rodrigue.kouete1@gmail.com" className="primary-btn">
                  Let's Talk
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
